import { useMediaQuery } from '@mui/material';
import { userIsCreator } from '../../services/users';
import { DEFAULT_SPACE_ID } from '../../services/spaces';
import {
  useGetCurrentSpaceMembershipQuery,
  useGetUserProfileQuery,
} from '../../app/smorgAppSyncGraphQLApiCustomHooks';

export const useIsMobile = () =>
  useMediaQuery((theme) =>
    theme ? theme.breakpoints.down('sm') : '(max-width:399px)',
  );

export const useHasMobileLikeLayout = () => {
  const { data: userProfile } = useGetUserProfileQuery();

  const isSmorgStudio = userIsCreator(userProfile);

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery(
    undefined,
    {
      skip: !userProfile || isSmorgStudio,
    },
  );

  const isCommunityUser = currentSpaceMembership?.spaceID === DEFAULT_SPACE_ID;

  return !isSmorgStudio && !isCommunityUser;
};

export const useHasBottomNav = () => {
  const isMobile = useIsMobile();

  const hasMobileLikeLayout = useHasMobileLikeLayout();

  if (isMobile) {
    return true;
  }

  // Desktop
  return hasMobileLikeLayout;
};
